import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, vShow as _vShow, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "text-uppercase" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return _withDirectives((_openBlock(), _createElementBlock("strong", _hoisted_1, [
    _createElementVNode("small", null, _toDisplayString(_ctx.label), 1)
  ], 512)), [
    [_vShow, _ctx.isGranted('VIEW_LEGAL_PHRASES')]
  ])
}